
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogUserLockErrorPasswordDialog extends Serenity.EntityDialog<LogUserLockErrorPasswordRow, any> {
        protected getFormKey() { return LogUserLockErrorPasswordForm.formKey; }
        protected getIdProperty() { return LogUserLockErrorPasswordRow.idProperty; }
        protected getLocalTextPrefix() { return LogUserLockErrorPasswordRow.localTextPrefix; }
        protected getNameProperty() { return LogUserLockErrorPasswordRow.nameProperty; }
        protected getService() { return LogUserLockErrorPasswordService.baseUrl; }
        protected getDeletePermission() { return LogUserLockErrorPasswordRow.deletePermission; }
        protected getInsertPermission() { return LogUserLockErrorPasswordRow.insertPermission; }
        protected getUpdatePermission() { return LogUserLockErrorPasswordRow.updatePermission; }

        protected form = new LogUserLockErrorPasswordForm(this.idPrefix);

    }
}